const getGoBoardCoordinateKey = (coordinate, boardSize) => coordinate.row * boardSize + coordinate.column;
export { getGoBoardCoordinateKey };